(function() {
    $(document).on('click', '.smp-basket-header', function() {
        $(this).parent().toggleClass('smp-active');
        if ($(window).width() > 475) {
            $('.smp-basket-overlay').toggleClass('smp-active');
            $('.sell-my-phone-container').toggleClass('clone-modal smp-expanded');
            $('.smp-basket-content').toggleClass('clone-modal');
            $('.smp-basket-header').toggleClass('open');
        } else {
            $('.smp-basket-sidepanel').toggleClass('smp-active');
            $('.smp-basket-overlay').toggleClass('smp-active');
            $('[data-trade-in-mobile]').html($('[data-trade-in-basket-container]').parent().html());
            $('.smp-basket-content-container').hide();
        }
    });

    $(document).on('click', '.search-results li', function() {
        $('.smp-basket-search-restart').show();
        $('.smp-basket-search-restart').toggleClass('clone-modal');
    });

    $(document).on('click', '.smp-basket-search-restart', function() {
        $(this).hide();
    });

    $(document).on('click', '[data-trade-in-basket-launch]', function() {
        $('[data-trade-in-basket-container]').load(
            $('[data-trade-in-basket-search-url]').data('tradeInBasketSearchUrl')
        );
    });
})($);

function closeNav() {
    $('.smp-basket-sidepanel').removeClass('smp-active');
    $('.smp-basket-overlay').removeClass('smp-active');
    $('.smp-basket-text').removeClass('open');
}
